import dayjs from "dayjs";

export const num = (n) =>
  n === null || n === undefined ? "—" : Math.round(n).toLocaleString("en-IN");

export const pct = (n, digits = 1) =>
  n === null || n === undefined || Number.isNaN(n) ? "—" : `${Number(n).toFixed(digits)}%`;

export const share = (part, whole) => (whole ? (part * 100) / whole : 0);

export const clockTime = (value) => (value ? dayjs(value).format("hh:mm A") : "—");

export const shiftTime = (value) =>
  value ? dayjs(`2000-01-01T${value}`).format("hh:mm A") : "";

export const longDate = (value) => (value ? dayjs(value).format("DD MMM YYYY") : "");

export const hours = (minutes) => {
  if (minutes === null || minutes === undefined) return "—";
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
};

export const fullName = (row) =>
  `${row.first_name || ""} ${row.last_name || ""}`.trim() || "—";

export const initials = (row) =>
  fullName(row)
    .split(/\s+/)
    .filter((w) => /[A-Za-z]/.test(w))
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

export const titleCase = (value) =>
  (value || "")
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const STATUS_META = {
  present: { label: "Present", tone: "green" },
  weekoff_present: { label: "Week Off Present", tone: "green" },
  working: { label: "Working", tone: "blue" },
  absent: { label: "Absent", tone: "red" },
  leave: { label: "Leave", tone: "amber" },
  weekoff: { label: "Week Off", tone: "grey" },
};

export const ISSUE_META = {
  not_punched_in: { label: "Not Punched In", tone: "grey" },
  missing_punch_out: { label: "Missing Punch Out", tone: "violet" },
  insufficient_hours: { label: "Insufficient Hours", tone: "amber" },
  multiple_punches: { label: "Multiple Punches", tone: "blue" },
  outside_geofence: { label: "Outside Geofence", tone: "red" },
  unusual_attendance: { label: "Unusual Attendance", tone: "red" },
};

// Plain-language explanation for the exception table "Detail" column
export const issueDetail = (row) => {
  const shift = row.shift_name
    ? `${row.shift_name} shift ${shiftTime(row.shift_from)}`
    : "Shift";
  const issue = (row.issues || [])[0];
  switch (issue) {
    case "not_punched_in":
      return `${shift} — no punch-in`;
    case "missing_punch_out":
      return `Punched in ${clockTime(row.punch_in)}, no punch-out`;
    case "insufficient_hours":
      return `Worked ${hours(row.worked)}, under 4h`;
    case "multiple_punches":
      return `${row.punches} punch segments`;
    case "outside_geofence":
      return "Punch-in outside the site radius";
    case "unusual_attendance":
      return "8 or more days present in a row";
    default:
      return "";
  }
};
